import {mapContentToStudyContent, studyWriteSchema, type Study, type StudyStatus} from '@cp/model';
import {setDoc} from 'firebase/firestore';
import {getStudyDocRef} from './getStudyDocRef';
import getStudyDocValidated from './getStudyDocValidated';

export default async function upsertStudyDoc(
  moduleId: string,
  topic: string,
  content: string,
  status?: StudyStatus,
): Promise<Study> {
  const studyContent = mapContentToStudyContent(content);
  const write = studyWriteSchema.partial().parse({studyContent, ...(status != null && {status})});
  const ref = getStudyDocRef(moduleId, topic);
  await setDoc(ref, write, {merge: true});
  return getStudyDocValidated(moduleId, topic);
}
